__turbopack_context__.v({
  "className": "inter_b2658fac-module__TEbsIa__className",
  "variable": "inter_b2658fac-module__TEbsIa__variable",
});
